<template>
    <div style="margin-left: -60px; margin-right: 60px; margin-top: -30px">
        <div class="itxst">
            <div class="col">
                <div class="title">PCS</div>
                <draggable v-model="arr1" group="pcs" animation="300" dragClass="dragClass" ghostClass="ghostClass" :move="onMove"
                           chosenClass="chosenClass">
                    <transition-group :style="style">
                        <div class="item" v-for="item in arr1" :key="item.deviceNo">
                            {{ item.deviceName }}
                            <div class="container">{{item.containerName}}</div>
                        </div>
                    </transition-group>
                </draggable>
            </div>

            <div style=" height: 100%; display: flex; align-items: center; justify-content: space-between; margin-top: 40px; position: relative; background: #3d3e3f;padding: 10px;">
                <div class="colinner" style="margin-right: 40px">
                    <div class="title">准备绑定的PCS</div>
                    <draggable v-model="arr3" group="pcs"  animation="300" dragClass="dragClass" ghostClass="ghostClass" :move="onMove"
                               chosenClass="chosenClass">
                        <transition-group :style="style1">
                            <div class="item" v-for="item in arr3" :key="item.deviceNo">
                                {{ item.deviceName }}
                                <div class="container">{{item.containerName}}</div>
                            </div>
                        </transition-group>
                    </draggable>
                </div>
                <div class="colinner">
                    <div class="title">准备绑定的堆</div>
                    <draggable v-model="arr4" group="dui"  animation="300" dragClass="dragClass" ghostClass="ghostClass" :move="onMove"
                               chosenClass="chosenClass">
                        <transition-group :style="style1">
                            <div class="item" v-for="item in arr4" :key="item.deviceNo">
                                {{ item.deviceName }}
                                <div class="container">{{item.containerName}}</div>
                            </div>
                        </transition-group>
                    </draggable>
                </div>
                <div style="width: 100%; position: absolute; bottom: -40px; left: 0; text-align: center">
                    <el-button size="small" type="primary" @click="subminAdd">新增分组</el-button>
                </div>
            </div>

            <div class="col">
                <div class="title">堆</div>
                <draggable v-model="arr2"  group="dui" animation="300" dragClass="dragClass" ghostClass="ghostClass" :move="onMove"
                           chosenClass="chosenClass">
                    <transition-group :style="style">
                        <div class="item" v-for="item in arr2" :key="item.deviceNo">
                            {{ item.deviceName }}
                            <div class="container">{{item.containerName}}</div>
                        </div>
                    </transition-group>
                </draggable>
            </div>
        </div>
        <div style="box-sizing: border-box; padding: 10px 0">
            <el-table :data="groupList" style="width: 100%" border size="mini" height="220" class="minRingTable">
                <el-table-column type="index" width="55"></el-table-column>
                <el-table-column  label="分组" prop="groupId" width="120"></el-table-column>
                <el-table-column  label="PCS"  prop="pcsNameList" ></el-table-column>
                <el-table-column  label="堆" prop="duiNameList"></el-table-column>
                <el-table-column  :label="$t('ems.alarm.operation')" align="center" width="120">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="deleteDict(scope.$index )" type="text" size="small" icon="el-icon-delete">{{ $t('ems.alarm.delete') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="footer">
            <el-button size="small" @click="close(false)">{{ $t('ems.strategy.cancel') }}</el-button>
            <el-button size="small" type="primary" @click="subminAddAll" :loading="saveLoading">{{
                $t('ems.strategy.confirm') }}
            </el-button>
        </div>
    </div>

</template>

<script>
    import draggable from "vuedraggable";
    import { getDeviceManagementList, updateDeviceGoup } from "@/api/spms";
    export default {
        components: {draggable},
        data() {
            return {
                list: [],
                drag: false,
                message: "",
                //定义要被拖拽对象的数组
                arr1: [
                ],
                arr2: [], //空数组
                arr3: [], //空数组
                arr4: [],
                //空数组之在的样式，设置了这个样式才能拖入
                style: "height:400px; display: block; overflow-y: auto;",
                style1: "height:300px; display: block; overflow-y: auto;",

                saveLoading: false,
                groupList: [],
            };
        },
        mounted(){
            this.init();
        },
        methods: {
            //开始拖拽事件
            onStart() {
                this.drag = true;
                return true;
            },
            //拖拽结束事件
            onEnd() {
                this.drag = false;
            },

            close(flag){
                this.$emit('close', flag);
            },

            onMove(e,originalEvent){
                return true;
            },

            subminAdd(){
                if(this.arr3.length === 0 || this.arr4.length === 0){
                    this.$message.warning("待绑定的PCS或堆不能为空！");
                    return false;
                }
                const a = {
                    groupId: "GROUP_temp" + (this.groupList.length + 1),
                    pcsList: JSON.parse(JSON.stringify(this.arr3)),
                    duiList: JSON.parse(JSON.stringify(this.arr4)),
                };
                a.pcsNameList = a.pcsList.map(i => i.deviceName).join(',');
                a.duiNameList = a.duiList.map(i => i.deviceName).join(',');
                a.pcsIds = a.pcsList.map(i => i.id).join(',');
                a.duiIds = a.duiList.map(i => i.id).join(',');
                this.groupList.push(a);
                this.arr3 = [];
                this.arr4 = [];
            },

            init(){
                getDeviceManagementList().then(res => {
                    if(res && res.data && res.data.data){
                        this.list = res.data.data;
                        this.arr1 = this.list.filter(i => i.deviceType == 'SXBLQ' && (i.bindTag === null || i.bindTag === ""));
                        this.arr2 = this.list.filter(i => i.deviceType == 'DUI'&& (i.bindTag === null || i.bindTag === ""));

                        const bindPcs = this.list.filter(i => i.deviceType == 'SXBLQ' && i.bindTag);
                        const bindDui = this.list.filter(i => i.deviceType == 'DUI' && i.bindTag);
                        const temp = [];
                        bindPcs.forEach(item => {
                            if( temp.includes(item.bindTag) === false){
                                temp.push(item.bindTag);
                            }
                        });
                        const groupList = [];
                        temp.forEach(item => {
                            const a = {
                                groupId: item,
                                pcsList: bindPcs.filter(i => i.bindTag == item),
                                duiList: bindDui.filter(i => i.bindTag == item),
                            };
                            a.pcsNameList = a.pcsList.map(i => i.deviceName).join(',');
                            a.duiNameList = a.duiList.map(i => i.deviceName).join(',');
                            a.pcsIds = a.pcsList.map(i => i.id).join(',');
                            a.duiIds = a.duiList.map(i => i.id).join(',');
                            groupList.push(a);
                        });
                        this.groupList = groupList
                    }
                })
            },

            deleteDict(index){
                const temp  = this.groupList[index];
                this.arr1 = [...this.arr1, ...temp.pcsList];
                this.arr2 = [...this.arr2, ...temp.duiList];
                this.groupList.splice(index, 1)
            },

            subminAddAll(){
                if(this.arr3.length !== 0 || this.arr4.length !== 0 || this.arr1.length !== 0 || this.arr2.length !== 0){
                    this.$message.warning("所有的PCS或堆都必须分组！");
                    return false;
                }
                this.saveLoading = true;
                updateDeviceGoup(this.groupList).then(res => {
                    if(res && res.data && res.data.success){
                        this.$message.success("保存成功！");
                        this.$emit("close", true);
                    }else{
                        this.saveLoading = false;
                    }
                }).catch(err => {
                    console.log(err);
                    this.saveLoading = false;
                })
            },

            closewin(){
                this.$emit("close", false);
            }
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/styles/site";

    /*定义要拖拽元素的样式*/
    .ghostClass {
        background-color: #4b79b7 !important;
    }

    .chosenClass {
        background-color: #515151 !important;
        opacity: 1 !important;
    }

    .dragClass {
        background-color: #515151 !important;
        opacity: 1 !important;
        box-shadow: none !important;
        outline: none !important;
        background-image: none !important;
    }

    .itxst {
        margin: 10px;
        display: flex;
        justify-content: space-between;
    }

    .title {
        color: $font_bright_blue_title;

        padding: 6px 12px;
    }

    .col {
        width:320px;
        padding: 10px;
        border: solid 1px #eee;
        border-radius: 5px;
    }

    .colinner {
        width:160px;
        padding: 10px;
        border: solid 1px #eee;
        border-radius: 5px;
    }

    .col + .col {
        margin-left: 10px;
    }

    .item {
        background-color: var(--nav_inner);
        width: 142px;
        height: 60px;
        box-sizing: border-box;
        padding: 5px;
        margin: 5px;
        float: left;
        user-select: none;
        color: $font_bright_blue_title;
        position: relative;
        .container{
            position: absolute;
            bottom: 5px;
            right: 5px;
            text-align: right;
            color: rgb(192, 192, 192);
        }
    }

    .item:hover {
        background-color: rgb(87, 87, 87);
        cursor: move;
    }

    .item + .item {
        border-top: none;
        margin-top: 6px;
    }

    .footer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 5px;
    }
</style>